
(() => {

	const run = () => {
		const markers = Array.from(document.getElementsByClassName('multi-section-wrapper'));
		
    if(markers.length < 2) return;

		const closestSection = (el) => el.closest('.shopify-section') || el;

		for(let i = 0; i < markers.length - 1; i += 2) {
			const startMarker = markers[i];
			const endMarker = markers[i + 1];
			const startSection = closestSection(startMarker);
			const endSection = closestSection(endMarker);
			if(!startSection || !endSection) continue;
			if(!(startSection.compareDocumentPosition(endSection) & Node.DOCUMENT_POSITION_FOLLOWING)) continue;
			const nextEl = startSection.nextElementSibling;
			if(nextEl && nextEl.hasAttribute('data-msw')) continue;
			const className = startMarker.dataset.groupClass || 'injected-section-wrapper';
			const container = document.createElement('div');
			container.className = className;
			container.setAttribute('data-msw', 'true');
			const sameParent = startSection.parentNode === endSection.parentNode;
			if(sameParent) {
				const parent = startSection.parentNode;
				while(startSection.nextSibling && startSection.nextSibling !== endSection) {
					container.appendChild(startSection.nextSibling);
				};
				parent.insertBefore(container, endSection);
			} else {
				const range = document.createRange();
				range.setStartAfter(startSection);
				range.setEndBefore(endSection);
				const fragment = range.extractContents();
				if(!fragment || !fragment.childNodes.length) continue;
				container.appendChild(fragment);
				endSection.parentNode.insertBefore(container, endSection);
			};
		};
	};

	if(document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', run, { once: true });
	} else {
		run();
	};

	document.addEventListener('shopify:section:load', run);
	document.addEventListener('shopify:section:reorder', run);

})();